// Auto-generated per-query builders for User
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { UserReadAPI, UserWriteAPI, UserReadAPISchema, UserWriteAPISchema } from '../types/user';
import { ModelRegistry } from '../../registries/model-registry';
import { CreatedBy, MemberOf, MemberOfClosure } from '../../relationships/relationship';

import { Group } from './group';
import { Step } from '../../chat/api/step';



// Field names for order_by on User
type UserFields = "created_at" | "-created_at" | "name" | "-name";



// Builder chain for query: base-all-users

export interface BaseAllUsersBuilder_0 {
  orderBy(field?: UserFields): BaseAllUsersBuilder_0;
}

export interface BaseAllUsersBuilder_0 {
  limit(value?: number): BaseAllUsersBuilder_0;
  all(): Promise<User[]>;
  first(): Promise<User | null>;
  get(): Promise<User[]>;
  execute(): Promise<User[]>;
}

// Builder chain for query: base-users-by-identifiers

export interface BaseUsersByIdentifiersBuilder_0 {
  filter(conditions: { identifiers: any }): BaseUsersByIdentifiersBuilder_1;
}

export interface BaseUsersByIdentifiersBuilder_1 {
  limit(value?: number): BaseUsersByIdentifiersBuilder_1;
  all(): Promise<User[]>;
  first(): Promise<User | null>;
  get(): Promise<User[]>;
  execute(): Promise<User[]>;
}

// Builder chain for query: base-user-by-id

export interface BaseUserByIdBuilder_0 {
  get(id: string): BaseUserByIdBuilder_1;
  filter(conditions: { id: string }): BaseUserByIdBuilder_1;
}

export interface BaseUserByIdBuilder_1 {
  all(): Promise<User[]>;
  first(): Promise<User | null>;
  get(): Promise<User[]>;
  execute(): Promise<User[]>;
}


// Union of all query entry points
export type UserQueryBuilder = BaseAllUsersBuilder_0 | BaseUsersByIdentifiersBuilder_0 | BaseUserByIdBuilder_0;

// Available query names for .setQuery()
export type UserQueryNames = "base-all-users" | "base-users-by-identifiers" | "base-user-by-id";

// Type narrowing for .setQuery()
export type UserBuilderForQuery<Q extends UserQueryNames> =
  Q extends "base-all-users" ? BaseAllUsersBuilder_0
  : Q extends "base-users-by-identifiers" ? BaseUsersByIdentifiersBuilder_0
  : Q extends "base-user-by-id" ? BaseUserByIdBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type UserInstanceQueryResult<Q extends UserQueryNames> =
  Q extends "base-all-users" ? BaseAllUsersBuilder_0
  : Q extends "base-users-by-identifiers" ? BaseUsersByIdentifiersBuilder_0
  : Q extends "base-user-by-id" ? BaseUserByIdBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  'order_by|limit': 'base-all-users',
  'filter|limit': 'base-users-by-identifiers',
  '': 'base-user-by-id',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends UserQueryNames>(queryName: Q): UserBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}


export interface User extends Partial<UserReadAPI> {}
export class User extends NeoNodeBase<UserReadAPI, UserWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "User";
  static readonly readSchema = UserReadAPISchema;
  static readonly writeSchema = UserWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    groups: { target: "Group", cardinality: "many", isParent: false, relClass: "MemberOf", direction: "out" },
    closure_groups: { target: "Group", cardinality: "many", isParent: false, relClass: "MemberOfClosure", direction: "out" },
    createdItems: { target: "Step", cardinality: "many", isParent: false, relClass: "CreatedBy", direction: "in" },
  };

  protected get modelName(): string {
    return 'User';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return User.label;
  }


  constructor(data: Partial<UserWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: UserReadAPI, loadContext?: Record<string, any>): User {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { groups, closure_groups, createdItems, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = UserReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, groups: groups, closure_groups: closure_groups, createdItems: createdItems };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return User.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadManyRelationship(processed, 'groups', 'Group', ModelRegistry);
    loadManyRelationship(processed, 'closure_groups', 'Group', ModelRegistry);
    loadManyRelationship(processed, 'createdItems', 'Step', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new User(processed as any);

    return instance;
  }

  static filter(conditions: { identifiers: any }): BaseUsersByIdentifiersBuilder_0;

  static filter(conditions: Record<string, any>): UserQueryBuilder;

  static filter(conditions: Record<string, any>): UserQueryBuilder {
    return new QueryBuilderImpl('User').filter(conditions) as any;
  }

  static all(): UserQueryBuilder {
    return new QueryBuilderImpl('User') as any;
  }

  static async first(): Promise<User | null> {
    const results = await new QueryBuilderImpl('User').execute();
    return results[0] || null;
  }


  static setQuery<Q extends UserQueryNames>(queryName: Q): UserBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('User');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends UserQueryNames>(queryName: Q): UserInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = User.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  // Relationship manager for 'groups' - Python ORM style (cached)
  get groups(): RelationshipManager<this, Group> {
    return this.getOrCreateRelationshipManager('groups', () => {
      return new RelationshipManager(this, 'groups', 'many', MemberOf as typeof Relationship);
    });
  }

  // Relationship manager for 'closure_groups' - Python ORM style (cached)
  get closure_groups(): RelationshipManager<this, Group> {
    return this.getOrCreateRelationshipManager('closure_groups', () => {
      return new RelationshipManager(this, 'closure_groups', 'many', MemberOfClosure as typeof Relationship);
    });
  }

  // Relationship manager for 'createdItems' - Python ORM style (cached)
  get createdItems(): RelationshipManager<this, Step> {
    return this.getOrCreateRelationshipManager('createdItems', () => {
      return new RelationshipManager(this, 'createdItems', 'many', CreatedBy as typeof Relationship);
    });
  }

}
